import { valueOf } from "@/types/common";

export const USER_TYPE = {
  ADMIN: "admin",
  ADMIN_MEMBER: "admin_member",
  MATCH_USER: "match_user",
};

export type TUserType = valueOf<typeof USER_TYPE>;

export const ADMIN_ROLE = {
  MANAGER: "manager",
  SALE: "company_sale",
  CUSTOM_SERVICE: "custom_service",
  AUDITOR: "auditor",
};

export type TAdminRole = valueOf<typeof ADMIN_ROLE>;

export enum EMatchContractStatus {
  DURING_CONTRACT = "during_contract",
  CANCELED_CONTRACT = "canceled_contract",
  TRIAL = "trial",
  TRIAL_CANCELLED = "trial_cancelled",
}

export type TMatchContractStatus = valueOf<typeof EMatchContractStatus>;

export const RESIDENCE_STATUS = {
  SPECIFIED_SKILL_NO1: 1,
  SPECIFIED_SKILL_NO2: 2,
  SPECIFIED_ACTIVITY: 3,
} as const;

export enum ESpecificSkillCertificateType {
  SPECIFIED_SKILL_NO1 = "1号",
  SPECIFIED_SKILL_NO2 = "2号",
}

export const SPECIFIC_SKILL_CERTIFICATE_TYPE = {
  [ESpecificSkillCertificateType.SPECIFIED_SKILL_NO1]: "1号",
  [ESpecificSkillCertificateType.SPECIFIED_SKILL_NO2]: "2号",
} as const;

export const LANGUAGE_CODE = {
  VI: "vi",
  MY: "my",
  ID: "id",
  EN: "en",
};

export type TLanguageCode = valueOf<typeof LANGUAGE_CODE>;

// Runtime environment injected at build time via REACT_APP_APP_ENV.
export const APP_ENV = {
  DEV: "DEV",
  STG: "STG",
  PROD: "PROD",
} as const;

export type TAppEnv = valueOf<typeof APP_ENV>;
